module.exports = __webpack_public_path__ + "img/banner.699cf920.png";